import React, { Component } from 'react';
import SamplePackNameComponent from 'components/samplepacks/SamplePackNameComponent.js';
import Sample from 'repos/Sample.js';
import SamplePackTagsComponent from 'components/samplepacks/SamplePackTagsComponent.js';
import SampleListComponent from 'components/samplepacks/SampleListComponent.js';
import SamplePacksListComponent from 'components/SamplePacksListComponent.js';
import SamplePackBlankComponent from 'components/samplepacks/SamplePackBlankComponent.js';
import SamplePack from 'repos/SamplePack.js';
import SamplePacks from 'decentralized/SamplePacks.js';
import EthereumCache from 'decentralized/cache/EthereumCache.js';
import EthereumSoundsSearcher from 'search/EthereumSoundsSearcher.js';

import '../../DrumMachineImportMode.css';
import '../../Common.css';
import './SamplePacks.css';

const samplePacks = new SamplePacks();

class SamplePacksComponent extends Component {

    constructor(props) {
        super(props);

        this.ethereumCache = new EthereumCache();
        this.ethereumSearcher = new EthereumSoundsSearcher(this.ethereumCache);
        this.state = {
            showSelectorView: false,
            showSamplePacks: false,
            tags: [],
            sounds: [],
            name: '',
            samplePack: undefined,
            blank: true,
        };
    }

    createNew() {
        this.setState({blank: false});
    }

    onClickNew() {
        if (window.confirm("Are you sure you want to clear and start over?")) {
            this.setState({
                sounds: [],
                blank: true,
                samplePack: undefined,
                showSamplePacks: false,
                showSelectorView: false,
                tags: [],
                name: ''});
        }
    }

    clearTags() {
        this.setState({tags: []});
    }

    showSamplePacks() {
        this.setState({blank: false,
                       showSamplePacks: true});
    }

    onClickSamplePack(samplePack) {
        this.setState({sounds: [], name: '', tags: [], samplePack: samplePack});

        // add all the samples in sample pack here
        for (let i in samplePack.samples) {
            let sample = samplePack.samples[i];
            let slices = samplePack.sampleToSlices[sample];
            this.addSound(sample, slices);
        }

        this.setState({name: samplePack.name});
        this.setState({tags: samplePack.tags});
    }

    onNameChanged(name) {
        this.setState({name: name});
    }

    async addSound(soundId, slices) {
        let sample = new Sample(soundId);
        sample.slices = slices;
        await sample.fetchMetadata();
        sample.fetchAudio()
            .then(() =>  {
                console.log('fetched the audio');
                console.log(sample);
                this.setState({sounds: this.state.sounds.concat([sample])})
            });
    }

    addTag(tag) {
        this.setState({tags: this.state.tags.concat([tag])});
    }

    deleteSound(i) {
        let sounds = this.state.sounds;
        sounds.splice(i, 1);
        this.setState({sounds: sounds});
    }

    onClickShowSelectorView() {
        this.setState({showSelectorView: !this.state.showSelectorView});
    }

    onClickHide() {
        this.setState({showSelectorView: false,
                       showSamplePacks: false});
    }

    saveSamplePack() {
        let sampleToSlices = {};
        let soundIds = [];
        for (let i in this.state.sounds) {
            let sound = this.state.sounds[i];
            soundIds.push(sound.ipfsHash);
            if (sound.slices !== undefined && sound.slices.length > 0) {
                sampleToSlices[sound.ipfsHash] = sound.slices;
            }
        }

        let samplePack = new SamplePack(this.state.name, soundIds, this.state.tags, sampleToSlices);

        if (this.state.samplePack !== undefined) {
            samplePacks.updateSamplePack(this.state.samplePack.id, samplePack);
        } else {
            samplePacks.newSamplePack(samplePack);
        }
    }

    render() {
        if (this.state.blank) {
            return (
                <div>
                  <div className="header">
                    SAMPLE PACK
                  </div>
                  <SamplePackBlankComponent
                    onClickCreate={() => this.createNew()}
                    onClickView={() => this.showSamplePacks()}/>
                </div>
            );
        }

        console.log('show sample packs = ' + this.state.showSamplePacks);

        return (
            <div className="sample-packs">
              <div className="header">
                SAMPLE PACK
              </div>
              <div className="main-container">
              <div className="sample-pack-pane">
                <SamplePackNameComponent
                  editingExisting={this.state.samplePack !== undefined}
                  name={this.state.name}
                  onNameChanged={(n) => this.onNameChanged(n)}>
                </SamplePackNameComponent>
                <SamplePackTagsComponent
                  onClearClicked={() => this.clearTags()}
                  onAddTag={(tag) => this.addTag(tag)}
                  tags={this.state.tags}/>
                <div className="main-buttons-container">
                  <div
                    onClick={() => this.saveSamplePack()}
                    className="common-button light-blue-button">
                    SAVE
                  </div>
                  <div
                    onClick={() => this.onClickNew()}
                    className="common-button light-blue-button">
                    NEW 
                  </div>
                </div>
                <SampleListComponent
                  onClickDelete={(i) => this.deleteSound(i)}
                  sounds={this.state.sounds}/>
            </div>
              <div className="sounds-searcher-pane">
                <div
                  onClick={() => {this.state.showSamplePacks || this.state.showSelectorView ? this.onClickHide() : this.onClickShowSelectorView()}}
                  className="light-blue-button common-button selector-button">
                  {this.state.showSamplePacks || this.state.showSelectorView ? 'HIDE' : 'SEARCH'}
                </div>
                {this.state.showSamplePacks ?
                  <SamplePacksListComponent
                        showDeleteButton={true}
                    onClickSamplePack={(samplePack) => this.onClickSamplePack(samplePack)}
                    /> : ''}
               </div>
              </div>
            </div>
        );
    }
}

export default SamplePacksComponent;
